import { Separator } from "@/components/ui/Separator"

import { Button } from "@/components/ui/Button"

import { BasicInformationForm } from "./components/StudentBasicInformation"
import { UpdatePasswordForm } from "./components/UpdatePassword"

import { StudentProfileController } from "./StudentProfile.controller"

interface StudentProfileProps {
  controller: StudentProfileController
}

export function StudentProfile({ controller }: StudentProfileProps) {
  return (
    <div className="tw-container tw-p-2">
      <h1 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-text-center">
        Student Profile
      </h1>

      <Separator className="tw-border-t tw-border-gray-200 tw-my-2" />

      <div className="tw-px-5">
        <BasicInformationForm user={controller.user} />
      </div>

      <Separator className="tw-border-t tw-border-gray-200 tw-my-10" />

      <div className="tw-px-5">
        <UpdatePasswordForm />
      </div>

      <Separator className="tw-border-t tw-border-gray-200 tw-my-10" />

      <div className="tw-px-5">
        <Button variant="destructive">Delete Account</Button>
      </div>
    </div>
  )
}
